import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'StepContent');

const StepContent = ({ children }) => {
    const classes = useStyles();
    return <div className={classes.stepContent}>{children}</div>;
};

StepContent.propTypes = {};

export default memo(StepContent);
